import axios from 'axios';
import { AUTH_TOKEN } from '../constants/message';
import { decode, encode } from '../utils/hashString';
import { EN_ACCEPT_LANGUAGE } from '../constants/acceptLanguageApi';
import { EMPLOYEE_REFRESH_TOKEN } from './endpoints/auth';

const axiosInstance = axios.create({
  // baseURL: process.env.REACT_APP_API_KEY,
  headers: {
    'Accept-Language': 'lo',
  },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  async (error) => {
    // Do something with response error
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;
      try {
        const authToken = localStorage.getItem(AUTH_TOKEN);
        if (authToken) {
          const authToken = localStorage.getItem(AUTH_TOKEN);
          const refreshToken: string = authToken
            ? decode(JSON.parse(authToken || '')?.refreshToken || '')
            : '';

          const { data: dataRefreshToken } = await axios.post(
            EMPLOYEE_REFRESH_TOKEN,
            {},
            {
              headers: {
                Authorization: refreshToken,
                'Accept-Language': EN_ACCEPT_LANGUAGE,
              },
            }
          );
          localStorage.setItem(
            AUTH_TOKEN,
            JSON.stringify({
              accessToken: encode(refreshToken),
              refreshToken: encode(dataRefreshToken?.refreshToken),
            })
          );
          originalRequest.headers.Authorization = refreshToken;
          axiosInstance.defaults.headers.common['Authorization'] = refreshToken;
          return axiosInstance(originalRequest);
        }
      } catch (error) {
        if (window.confirm('Session Expired, You need to logout')) {
          localStorage.clear();
          window.location.href = 'auth/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
